import Vuex from "vuex";
import Vue from "vue";
import ui from "./modules/ui";
import data from "./modules/data";
import scroller from "./modules/scroller";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ui,
    data,
    scroller,
  },
});
